import { numToChinese } from '@/apps/question/model/numberToChinese'
import { Component, Vue } from 'vue-property-decorator'
import { layout } from './layout-data'
import {
  getDotMatrixCard,
  getDotMatrixPaper,
  getDotMatrixTypeset,
  getTeacherGroupInfo,
  publishDotMatrix,
  publishDotMatrixTypeset,
  updateDotMatrixCard
} from './models/api'

@Component({})
export default class CartPreview extends Vue {
  // 学科id
  public subjectId = 101
  // loading
  public spinning = false
  // 班组信息
  public clazzInfo: any = {}
  // 是否铺码
  public isNeedPourPoint: any = false
  // 试卷id
  public dotMatrixPaperId: any = undefined
  // 试卷排版状态 checked、typesetted、published
  public dotMatrixStatus = ''
  // 原始试卷信息
  public treeData: any = {
    page_layout: {
      block_padding: 0,
      bottom_padding: 0,
      h: 0,
      left_padding: 0,
      right_padding: 0,
      solving_answer_line_height: 0,
      top_padding: 0,
      w: 0,
    }
  }
  // 试卷名称
  public dotMatrixPaperTitle = ''
  // 转换后的试卷数据
  public paperData: any = []
  // 班级数据
  public gradesData: any = []
  // 订正与反思
  public correction = true
  // 作业与反馈
  public feedback = false
  // mounted
  public mounted() {
    this.dotMatrixPaperId = this.$route.query.dotMatrixPaperId
    this.isNeedPourPoint = this.$route.query.isNeedPourPoint
    this.clazzInfo = this.$route.query.clazzInfo
    this.getDotMatrixPaper()
    this.getDotMatrixTypeset()
    this.getDotMatrixCard()
  }
  // 获取订正与反思
  public async getDotMatrixCard() {
    const res: any = await getDotMatrixCard({
      dot_matrix_paper_id: this.dotMatrixPaperId
    })
    if (!res.success) {
      this.$message.error(res.error)
      return
    }
    this.correction = res.data.has_correction
    this.feedback = res.data.has_homework_feedback
  }
  // 获取点阵试卷名
  public async getDotMatrixPaper() {
    const res: any = await getDotMatrixPaper({
      dot_matrix_paper_id: this.dotMatrixPaperId
    })
    if (!res.success) {
      this.$message.error(res.error)
      return
    }
    this.subjectId = res.data.subject_id
    this.dotMatrixPaperTitle = res.data.title
    this.dotMatrixStatus = res.data.status
    // 获取班级信息
    this.getTeacherGroupInfo()
  }
  // 获取试卷信息
  public async getDotMatrixTypeset() {
    this.spinning = true
    const res: any = await getDotMatrixTypeset({
      dot_matrix_paper_id: this.dotMatrixPaperId
    })
    if (!res.success) {
      this.spinning = false
      this.$message.error(res.error)
      return
    }
    let { has_homework_feedback, has_correction } = res.data.card_config
    let { homework_feedback_layout } = res.data.expand
    // 有作业反馈添加到最后一页的最后一题
    let feedback = homework_feedback_layout ? {
      answer_area: {
        w: homework_feedback_layout.w, h: homework_feedback_layout.h
      },
      has_solving_answer_area: has_homework_feedback,
      layout: {
        w: homework_feedback_layout.w, h: homework_feedback_layout.h
      },
      id: 'feedback',
      q_id: 'feedback',
      solving_answer_area: {
        layout: {
          w: homework_feedback_layout.w, h: homework_feedback_layout.h
        }
      }
    } : {}
    // tslint:disable-next-line:no-unused-expression
    has_homework_feedback
      && res.data.group_data[res.data.group_data.length - 1].questions.push(feedback)
    this.treeData = res.data
    let i = 0
    this.treeData.group_data.forEach((item, index) => {
      // 阿拉伯数字转为中文
      if ([2, 3].includes(numToChinese(index + 1).length) && numToChinese(index + 1)[0] == '一') {
        item.group_title.indexTitle = numToChinese(index + 1).substr(1)
      } else {
        item.group_title.indexTitle = numToChinese(index + 1)
      }
      item.questions.forEach(itm => {
        itm.index = i++
      })
    })
    this.paperData = layout(this.treeData)
    this.spinning = false
    this.setFeedStyle()
  } 
  // 获取班级信息
  public async getTeacherGroupInfo() {
    const res: any = await getTeacherGroupInfo({
      subject_id: this.subjectId
    })
    if (!res.success) {
      this.$message.error(res.error)
      return
    }
    this.gradesData = res.data.clazzList
  }
  // 树查找数据
  public searchTree(tree, qid, type) {
    for (let item of tree) {
      if (item.id == qid) {
        if (type == 'add') {
          item.solving_answer_area.layout.h += this.treeData.page_layout.solving_answer_line_height
        } else {
          item.solving_answer_area.layout.h -= this.treeData.page_layout.solving_answer_line_height
        }
        this.paperData = layout(this.treeData)
        this.setFeedStyle()
        return item
      } else if (item.sub_qs.length) {
        this.searchTree(item.sub_qs, qid, type)
      }
    }
  }
  // 键盘事件
  public keydown(e, id, h) {
    // 排版过不能编辑
    if (this.dotMatrixStatus == 'published') return
    // 限制最大输入50行
    if (e.keyCode == 13 && h < this.treeData.page_layout.solving_answer_line_height * 50) {
      for (let item of this.treeData.group_data) {
        let result = this.searchTree(item.questions, id, 'add')
        if (result) return
      }
    } else if (e.keyCode == 8 && h > this.treeData.page_layout.solving_answer_line_height) {
      for (let item of this.treeData.group_data) {
        let result = this.searchTree(item.questions, id, 'cut')
        if (result) return
      }
    }
  }
  // 设置作业反馈样式
  public setFeedStyle() {
    // tslint:disable-next-line:no-unused-expression
    this.correction && this.$nextTick(() => {
      let textlines: any = document.getElementsByClassName('textline')
      let correction: any = document.getElementsByClassName('correction')[0]
      let qsItem3: any = document.getElementsByClassName('qs_item')[2]
      correction.style.top = qsItem3.style.top
      for (let i = 0; i < textlines.length; i ++) {
        textlines[i].style.height = '100%'
      }
    })
    // tslint:disable-next-line:no-unused-expression
    this.feedback && this.$nextTick(() => {
      let lastNode: any = document.getElementById(`textline${this.paperData.length - 1}`)
      let lastNodeNext: any = lastNode.nextSibling
      if (lastNode && !lastNodeNext) {
        lastNode.style.marginLeft = 0
        lastNode.style.width = '710px'
      }
    })
    // tslint:disable-next-line:no-unused-expression
    this.correction && this.feedback && this.$nextTick(() => {
      let textlines: any = document.getElementsByClassName('textline')
      let corrections: any = document.getElementsByClassName('correction')
      let qsItem3: any = document.getElementsByClassName('qs_item')[2]
      corrections[0].style.top = qsItem3.style.top
      for (let i = 0; i < textlines.length; i ++) {
        textlines[i].style.height = '100%'
      }
      let feed: any = document.getElementById('textarea-feedback')
      let top = feed.parentNode.parentNode.style.top
      let target = feed.parentNode.parentNode.parentNode.firstChild
      target.style.height = top
      let lastNode: any = document.getElementById(`textline${textlines.length - 1}`)
      let lastNodeNext: any = lastNode.nextSibling
      let prev: any = null
      if (lastNode && !lastNodeNext) {
        lastNode.style.marginLeft = 0
        lastNode.style.width = '710px'
        prev = lastNode.parentNode.firstChild
        prev.style.display = 'none'
        corrections[corrections.length - 1].style.display = 'none'
      }
    })
  }
  // 订正与反思
  public async onCorrection(e) {
    this.spinning = true
    try {
      const res: any = await updateDotMatrixCard({
        dot_matrix_paper_id: +this.dotMatrixPaperId,
        page_type: e.target.value ? 'narrow_A4' : 'wide_A4',
        has_correction: e.target.value,
        has_homework_feedback: this.feedback
      })
      if (!res.success) {
        this.$message.error(res.error)
        this.spinning = false
        return
      }
      this.spinning = false
      this.getDotMatrixTypeset()
    } catch (err) {
      this.$message.error(err.error)
      this.spinning = false
    }
  }
  // 作业反馈
  public async onFeedback(e) {
    this.spinning = true
    try {
      const res: any = await updateDotMatrixCard({
        dot_matrix_paper_id: +this.dotMatrixPaperId,
        page_type: this.correction ? 'narrow_A4' : 'wide_A4',
        has_correction: this.correction,
        has_homework_feedback: e.target.value
      })
      if (!res.success) {
        this.$message.error(res.error)
        this.spinning = false
        return
      }
      this.spinning = false
      this.getDotMatrixTypeset()
    } catch (err) {
      this.$message.error(err.error)
      this.spinning = false
    }
  }
  // 提交排版信息
  public async postData() {
    // 发布过的不能再次发布
    if (this.dotMatrixStatus == 'published') {
      return
    }
    this.spinning = true
    let areas: any = []
    let feed: any = {}
    // 只提交带有作答区域的
    this.paperData.forEach(paper => {
      paper.blocks.forEach(block => {
        if (block.canAdjust && block.qid !== 'feedback') {
          areas.push({
            id: block.qid,
            layout: {
              w: block.answerWidth,
              h: block.answerHeight
            }
          })
        }
        if (block.qid === 'feedback') {
          feed.w = block.answerWidth
          feed.h = block.answerHeight
        }
      })
    })
    try {
      const res: any = await publishDotMatrixTypeset({
        dot_matrix_paper_id: +this.dotMatrixPaperId,
        solving_areas: areas,
        has_homework_feedback: this.feedback,
        homework_feedback_layout: feed
      })
      if (!res.success) {
        this.$message.error(res.error)
        this.spinning = false
        return
      }
      this.publishDotMatrix()
    } catch (err) {
      this.spinning = false
    }
  }
  // 发布
  public async publishDotMatrix() {
    let list: any = []
    if (!this.clazzInfo) {
      this.$message.error('班组信息为空')
      this.spinning = false
      return
    }
    let clazzInfoObj
    try {
      clazzInfoObj = JSON.parse(this.clazzInfo)
    } catch (err) {
      this.$message.error('参数错误')
      this.spinning = false
      return
    }
    // 所选年级
    let target = this.gradesData.find(item => item.clazzLevel == clazzInfoObj.clazzLevel).clazzs
    target.forEach(item => {
      clazzInfoObj.clazzs.forEach(clazz => {
        // 未选择全部分组
        if (clazz.teamList.length) {
          if (clazz.groupId == item.groupId) {
            clazz.teamList.forEach(teamId => {
              item.teamList.forEach(itm => {
                // 分组id相等获取下面的学生id
                if (teamId == '-1') teamId = '' // -1代表未分组
                if (teamId == itm.teamId) {
                  list.push({
                    group_id: clazzInfoObj.clazzLevel,
                    student_ids: itm.studentList.map(el => el.studentId)
                  })
                }
              })
            })
          }
          // 选择全部分组
        } else {
          if (clazz.groupId == item.groupId) {
            // 全部分组获取所有分组下的学生id
            item.teamList.forEach(itm => {
              list.push({
                group_id: clazzInfoObj.clazzLevel,
                student_ids: itm.studentList.map(el => el.studentId)
              })
            })
          }
        }
      })
    })
    if (!list.length) {
      this.$message.error('发布对象为空')
      this.spinning = false
      return
    }
    try {
      const res: any = await publishDotMatrix({
        dot_matrix_paper_id: +this.dotMatrixPaperId,
        students: list,
        is_need_pour_point: Boolean(+this.isNeedPourPoint),
        supplier: this.$route.query.supplier
      })
      this.spinning = false
      if (!res.success) {
        this.$message.error(res.error)
        return
      }
      // 下载url
      window.open(`${res.data.url}`)
      // 刷新页面
      this.getDotMatrixPaper()
      this.getDotMatrixTypeset()
    } catch (err) {
      this.spinning = false
    }
  }
}
